import styles from "./style.module.scss";
import classNames from "classnames";

const Loader = ({
  progress = 0,
  className,
}: {
  className?: string;
  progress: number;
}) => {
  const scale = Math.max(0, Math.min(progress / 100, 1));

  return (
    <div
      className={classNames(styles.progressContainer, className)}
      style={{ ["--glow-width" as any]: `${scale * 100}%` }}
    >
      <div className={classNames(styles.progressBar, "progressBar")}>
        <div
          className={styles.progressFill}
          style={{ transform: `scaleX(${scale})` }}
        />
      </div>
    </div>
  );
};

export default Loader;
